import React, { useState, useEffect } from 'react';
import NoApplications from './NoApplications';
import { Box as ApplicationBox } from './Application';
import styled from 'styled-components';
import Breadcrumbs from './Breadcrumbs';
import { useDeals } from '../../hooks/useDeals';
import Loading from '../../components/common/Loading';

const List = styled.div`
  > * {
    margin-bottom: 20px;
  }

  > :last-child {
    margin-bottom: 0;
  }
`;

const Applications =  () => {
  const { fetchDeals, deals: applications, isLoading } = useDeals();
  const [hasFirstLoadFinished, setHasFirstLoadFinished] = useState(false);

  const triggerRefreshMyBunacDataByInterval = async () => {
    const sleep = async ({ ms }) =>
      new Promise(resolve => setTimeout(resolve, ms));
    let currentRefreshIndex = 0;

    const refreshMyBunacData = async () => {
      if (
        window.location.pathname !== '/mybunac' &&
        window.location.pathname !== '/mybunac/'
      ) {
        return true;
      }
      if (currentRefreshIndex < 15) {
        await fetchDeals();
        currentRefreshIndex += 1;
        await sleep({ ms: 2000 });
        await refreshMyBunacData();
      }
    };

    await refreshMyBunacData();
  };

  useEffect(() => {
    if (!hasFirstLoadFinished && !isLoading && applications.length) {
      setHasFirstLoadFinished(true);
    }
  }, [isLoading, hasFirstLoadFinished, applications]);

  useEffect(() => {
    triggerRefreshMyBunacDataByInterval();
  }, []);

  return (
    <>
      <Breadcrumbs />
      {hasFirstLoadFinished && (!applications || !applications.length) && (
        <NoApplications />
      )}
      {!hasFirstLoadFinished && <Loading text="Loading your Applications" />}
      {!!hasFirstLoadFinished && (
        <List>
          {applications.map(application => (
            <ApplicationBox key={application.id} application={application} />
          ))}
        </List>
      )}
    </>
  );
};

export default Applications;